import { Grid } from '@mui/material';
import { ITrainingViewDto } from 'generated/CoreApi_v1';
import { TrainingViewDurationBox, TrainingViewMultipleClassesBox } from 'views/lms/training/components/TrainingViewBoxes';

interface IProps {
    trainingView: ITrainingViewDto | null;
    onClick: () => void;
}

export const RegistrationMultipleClassesHighlights = ({ trainingView, onClick }: IProps) => {
    return trainingView == null
        ? null
        : (
            <Grid container justifyContent="space-between" alignItems="center" width="100%" spacing={2}>
                <Grid size={{ xs: 4 }}>
                    <TrainingViewMultipleClassesBox {...trainingView} onClick={onClick} />
                </Grid>

                {
                    trainingView.trainingDurationFormated &&
                    <Grid size={{ xs: 4 }}>
                        <TrainingViewDurationBox {...trainingView} />
                    </Grid>
                }

            </Grid>
        );
};
